var _path, _rect, _rect2, _rect3, _path2, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDigitaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_digitaly",
    "data-name": "logo digitaly",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.874,
    height: 14.831,
    viewBox: "0 0 13.874 14.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M0,0V14.831H9.752c2.686,0,4.122-1.656,4.122-4.453V0Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_15",
    "data-name": "Ret\\xE2ngulo 15",
    width: 2.65,
    height: 0.699,
    transform: "translate(3.938 7.707)",
    fill: "#4385c6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_16",
    "data-name": "Ret\\xE2ngulo 16",
    width: 2.65,
    height: 0.699,
    transform: "translate(3.938 8.989)",
    fill: "#4385c6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_17",
    "data-name": "Ret\\xE2ngulo 17",
    width: 2.65,
    height: 0.699,
    transform: "translate(3.938 6.425)",
    fill: "#4385c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M338.837,380.344h2.947a6.06,6.06,0,0,0,.2-.7h-3.146Z",
    transform: "translate(-330.815 -370.656)",
    fill: "#4385c6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_18",
    "data-name": "Ret\\xE2ngulo 18",
    width: 2.65,
    height: 0.733,
    transform: "translate(3.938 5.109)",
    fill: "#4385c6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M116.843,99.48h-4.931v.779h7.038a3.158,3.158,0,0,0-2.107-.779",
    transform: "translate(-109.262 -97.125)",
    fill: "#4385c6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M111.909,494.651h4.931a3.28,3.28,0,0,0,1.986-.632h-6.917Z",
    transform: "translate(-109.259 -482.323)",
    fill: "#4385c6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M111.912,157.8h8.073a4.691,4.691,0,0,0-.489-.81h-7.584Z",
    transform: "translate(-109.262 -153.271)",
    fill: "#4385c6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M338.837,216.528h3.145a6.327,6.327,0,0,0-.206-.733h-2.94Z",
    transform: "translate(-330.815 -210.686)",
    fill: "#4385c6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M338.837,325.506v.7h3.248c.03-.228.049-.462.058-.7Z",
    transform: "translate(-330.815 -317.799)",
    fill: "#4385c6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M338.837,272.06h3.306c-.009-.236-.028-.47-.058-.7h-3.248Z",
    transform: "translate(-330.815 -264.936)",
    fill: "#4385c6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M119.984,433.788h-8.075v.843h7.532a4.291,4.291,0,0,0,.544-.843",
    transform: "translate(-109.259 -423.518)",
    fill: "#4385c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDigitaly);
export default __webpack_public_path__ + "static/media/logo-digitaly.b18f7c8381f9ae2f04b7e9fe91c26fcf.svg";
export { ForwardRef as ReactComponent };